import React, { createContext, useContext } from "../../__compat__/react/main.entry.mjs.mjs";
import { en_US } from "./en_US.mjs.mjs";
const LocaleContext = createContext(en_US);
export const useLocale = () => useContext(LocaleContext);
export const LocaleProvider = ({ locale = {}, children }) => (React.createElement(LocaleContext.Provider, { value: {
        ...en_US,
        ...locale,
    } }, children));
//# sourceMappingURL=LocaleProvider.mjs.mjs.map